/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  confirmRegister,
  postJwtRegister,
  postRecoverPassword,
  postRegister,
  postResetPassword,
  resendEmail,
} from "../../../helpers/fakebackend_helper";

// action
import { registerUserFailed, resetRegisterFlagChange } from "./reducer";

// initialize relavant method of both Auth

// Is user register successfull then direct plot user in redux.
export const registerUser =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = postRegister(user);
      }
      let data: any = await response;
      if (data) {
        history("/register/mail", { state: { email: data?.email } });
      }
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };

export const recoverPassword =
  (email: any, setSuccess: any, setError: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = postRecoverPassword(email);
      }
      let data: any = await response;

      if (data.email) {
        setSuccess(true)
      } else {
        setError(true)
      }
      return data;
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };

export const resetPassword =
  (data: any, setSuccess: any, setError: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = postResetPassword(data);
      }
      let user: any = await response;

      if (user.email) {
        setSuccess(true)
      } else {
        setError(true)
      }
      return user;
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };

export const confirmRegisteredUser =
  (token: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = confirmRegister(token);
      }
      let data: any = await response;
      if (data.email) {
        setTimeout(() => history("/login"), 3000);
      }
      return data;
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };

export const resendAuthenticationEmail =
  (token: any, setResendedEmail: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = resendEmail(token);
      }
      let data: any = await response;
      setResendedEmail(true);
      return data;
    } catch (error: any) {
      dispatch(registerUserFailed(error));
    }
  };

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};
